import React from 'react'
import { useTranslation } from 'react-i18next'

import '../../css/common/ErrorBox.css'

export type ErrorMessage = {
  heading: string
  content: string
}

type ErrorBoxProps = {
  isOpen: boolean
  onClose: () => void
  errorMessage: ErrorMessage
}

/**
 * ErrorBox component displays an error message in a modal-like box.
 *
 * @param {ErrorBoxProps} props - The properties object.
 * @param {boolean} props.isOpen - Indicates if the error box is open.
 * @param {Function} props.onClose - Function to call when closing the error box.
 * @param {ErrorMessage} props.errorMessage - The error message to display.
 * @returns {JSX.Element} The rendered error box component.
 */
const ErrorBox: React.FC<ErrorBoxProps> = ({
  isOpen,
  onClose,
  errorMessage,
}): JSX.Element => {
  const { t } = useTranslation()
  return isOpen ? (
    <div className={`error-box-container ${isOpen ? 'open' : ''}`}>
      <div className="error-box-wrapper">
        <div className="error-box">
          <div className="error-box-content">
            <h2 className="error-box-heading">{errorMessage.heading}</h2>
            <p className="responsive-font">{errorMessage.content}</p>
          </div>
          <button
            className="error-box-button responsive-button"
            onClick={onClose}
          >
            {t('ok')}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ErrorBox
